import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { JobFormPage } from "~/pages/JobsFormPage";
import { useJobLabels } from "~/hooks/useJobLabels";
import { queryClient, trpc } from "~/utils/trpc";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/jobs/edit/$id")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const job = await queryClient.fetchQuery(trpc.jobs.getById.queryOptions({ id: params.id, with: ["client_name"] }));
    return { job };
  },
  gcTime: 0,
  staleTime: 0,
});

function RouteComponent() {
  const { job } = Route.useLoaderData();
  const { plural } = useJobLabels();
  useBreadCrumbs([
    { title: plural, link: `/${location.pathname.split("/")[1]}/data/jobs` },
    { title: "Edit", link: `/${location.pathname.split("/")[1]}/data/jobs/edit/${job.id}` },
  ]);
  return <JobFormPage job={job} />;
}
